/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deceased_BadgeInputs */



/**
* | output |
* | --- |
* | "In memoriam" |
*
* @param {Deceased_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deceased_badge = /** @type {((inputs?: Deceased_BadgeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deceased_BadgeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("In memoriam")
	if (locale === "es") return /** @type {LocalizedString} */ ("In memoriam")
	if (locale === "pt") return /** @type {LocalizedString} */ ("In memoriam")
	if (locale === "it") return /** @type {LocalizedString} */ ("In memoriam")
	return /** @type {LocalizedString} */ ("In memoriam")
});